import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import { tagParser } from '../../js/modules/utilities'
import { attributesAnalytics } from '../../js/modules/component'
import background from './bg-nature.webp'

// Swiper JS
import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

// Fonction pour nettoyer une chaîne en supprimant toutes les balises [] et leur contenu
const cleanTagsFromString = (str) => {
   if (!str) return ''
   return str.replace(/\[.*?\]/g, '')
}

export const Re = ({ title, description, CTA, items, cacheKey }) => {
   useEffect(() => {
      let swiper_re = new Swiper('.swiper-re', {
         modules: [Pagination],
         pagination: {
            enabled: true,
            el: '.swiper-pagination',
            clickable: true,
            bulletClass: 'swiper-pagination-aloha',
            bulletActiveClass: 'swiper-pagination-aloha-active',
            horizontalClass: 'swiper-pagination-aloha-horizontal',
            renderBullet: function (index, className) {
               return '<span class="' + className + '"><span></span></span>'
            },
         },
         direction: 'horizontal',
         preventClicks: false,
         loop: false,
         slidesOffsetBefore: 15,
         slidesOffsetAfter: 15,
         spaceBetween: 15,
         slidesPerView: 'auto',
         breakpoints: {
            // when window width is >= 736px
            736: {
               pagination: {
                  enabled: true,
               },
               slidesOffsetBefore: 30,
            },
            // when window width is >= 960px
            960: {
               pagination: {
                  enabled: false,
               },
               slidesOffsetBefore: 0,
            },
            // when window width is >= 1200px
            1200: {
               pagination: {
                  enabled: false,
               },
               slidesOffsetBefore: 0,
               allowTouchMove: false,
            },
         },
      })
   }, [])

   return (
      <div class="re mt-3 mt-md-4" data-cache-key={cacheKey}>
         <div class="background-nature">
            <img src={background} alt="" loading="lazy" />
         </div>
         <div class="container-fluid">
            <div class="titre">
               <h2 class="main no-signature text-white m-0 p-0">
                  <span aria-label={cleanTagsFromString(title)} dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
               </h2>
               <p class="description" dangerouslySetInnerHTML={{ __html: tagParser(description) }} />
               <a
                  href={CTA.URL}
                  class="btn btn-primary btn-inverse"
                  aria-label={CTA.ariaLabel}
                  {...attributesAnalytics(CTA.analytics)}
               >
                  {CTA.label}
               </a>
            </div>
            <div class="swiper-re">
               <ul class="tuile-list swiper-wrapper">
                  {items &&
                     items.map((item, index) => (
                        <li class="tuile-list-slide swiper-slide" key={index}>
                           <Tuile image={item.image} title={item.title} badge={item.badge} URL={item.URL} target={item.target} analytics={item.analytics} />
                        </li>
                     ))}
               </ul>
               <div class="swiper-pagination" aria-hidden="true"></div>
            </div>
         </div>
      </div>
   )
}

const Tuile = ({ image, title, badge, URL, target, analytics }) => {
   return (
      <a
         class="tuile-re"
         href={URL}
         target={target}
         aria-label={badge + ' : ' + title}
         {...attributesAnalytics(analytics)}
      >
         <div class="img-container">
            <img class="img" src={image} alt="" loading="lazy" />
         </div>
         <div class="tuile-titre">
            <div class="badge">{badge}</div>
            <h3 class="lead font-weight-bold mb-0 pt-0" dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
         </div>
      </a>
   )
}
